export default {
  en: {
    qtyAppointments: {
      label: 'Qty of appointments',
      hint: 'View the number of schedules for each of its states',
    },
    durationOfAppointments: {
      label: 'Avg duration of meetings',
      hint: 'View the average duration of meetings in minutes'
    },
    listOfAppointments: {
      label: 'List of appointments',
      hint: 'View the meeting list',
      reassign: 'Reassign agent',
    },
    filters: {
      agent: 'Filter by agent',
      segment: 'Filter by segment',
      service: 'Filter by calendar',
    },
    statuses: {
      pending: 'Pending',
      attended: 'Attended',
      canceled: 'Canceled',
      rescheduled: 'Rescheduled',
    },
    reassign: {
      title: 'Reassign agent',
      context: 'Reassign meeting at',
      chooseAgent: 'Select an agent',
    }
  },
  es: {
    qtyAppointments: {
      label: 'Cantidad de citas',
      hint: 'Visualiza el número de horarios para cada uno de sus estados',
    },
    durationOfAppointments: {
      label: 'Duración promedio de las reuniones',
      hint: 'Visualiza la duración promedio de las reuniones en minutos'
    },
    listOfAppointments: {
      label: 'Lista de citas',
      hint: 'Visualiza la lista de reuniones',
      reassign: 'Reasignar agente',
    },
    filters: {
      agent: 'Filtrar por agente',
      segment: 'Filtrar por segmento',
      service: 'Filtrar por calendario',
    },
    statuses: {
      pending: 'Pendiente',
      attended: 'Atendida',
      canceled: 'Cancelada',
      rescheduled: 'Reagendada',
    },
    reassign: {
      title: 'Reasignar agente',
      context: 'Reasignar reunión a',
      chooseAgent: 'Seleccionar un agente',
    }
  },
  fr: {
    qtyAppointments: {
      label: 'Quantité de rendez-vous',
      hint: 'Voir le nombre de plannings pour chacun de ses états',
    },
    durationOfAppointments: {
      label: 'Durée moyenne des réunions',
      hint: 'Voir la durée moyenne des réunions en minutes'
    },
    listOfAppointments: {
      label: 'Liste des rendez-vous',
      hint: 'Voir la liste des réunions',
      reassign: 'Réaffecter l\'agent',
    },
    filters: {
      agent: 'Filtrer par agent',
      segment: 'Filtrer par segment',
      service: 'Filtrer par calendrier',
    },
    statuses: {
      pending: 'En attente',
      attended: 'Assuré',
      canceled: 'Annulé',
      rescheduled: 'Reprogrammé',
    },
    reassign: {
      title: 'Réaffecter l\'agent',
      context: 'Réaffecter la réunion à',
      chooseAgent: 'Sélectionner un agent',
    }
}

}
